// CORE
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";



// INTERNAL MODULE
import { AngularMaterialModule } from "./../../angular-material/angular-material.module";
import { HelpersModule } from "./../../helpers/helpers.module";
import { PipesModule } from "./../../pipes/Pipes.module";
import { SignalDesignModule } from './../../signal-design/signal-design.module';

// COMPONENTS
import { ButtonFuentesMenuComponent } from "./buttonFuentesMenu/buttonFuentesMenu.component";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { DateInputDialogComponent } from "./date-input-dialog/date-input-dialog.component";
import { CountryListComponent } from "./country-list/country-list.component";
import { FloatButtonComponent } from "./float-button/float-button.component";
import { FooterComponent } from "./footer/footer.component";
// import { FuenteDinamicaComponent } from "./fuente-dinamica/fuente-dinamica.component";
// import { FuenteDinamicaDetailComponent } from "./fuente-dinamica/fuente-dinamica-detail/fuente-dinamica-detail.component";
import { FormularioDinamicoComponent } from './formulario-dinamico/formulario-dinamico.component';
import { HistorialFuentesPanelComponent } from "./historial-fuentes-panel/historial-fuentes-panel.component";
import { HomeComponent } from "./home/home.component";
import { HomeSearcherComponent } from "./home-searcher/home-searcher.component";
import { MensajeComponent } from "./mensaje/mensaje.component";
import { ModalComponent } from "./modal/modal.component";
import { ModalAbmBuscadorComponent } from "./modal-abm-buscador/modal-abm-buscador.component";
import { ModalEliminacionMasivaComponent } from './modal-eliminacion-masiva/modal-eliminacion-masiva.component';
import { ModalBcraComponent } from './modal-bcra/modal-bcra.component';
import { ModalLateralComponent } from './modal-lateral/modal-lateral.component';
import { NavbarComponent } from "./navbar/navbar.component";
import { NominativeComponent } from "./nominative/nominative.component";
import { NominativeRdsComponent } from "./nominative-rds/nominative-rds.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { OverlayLoadingComponent } from "./overlay-loading/overlay-loading.component";
import { PreviewDataTableFuenteComponent } from "./previewDataTableFuente/previewDataTableFuente.component";
import { PreviewDataTableTitleComponent } from './previewDataTableFuente/previewDataTableTitleSection/previewDataTableTitle/previewDataTableTitle.component';
import { SidebarComponent } from "./sidebar/sidebar.component";
import { TabsSourcesComponent } from "./tabs-sources/tabs-sources.component";
// PROVIDERS
import { HealthComponent } from './health/health.component';
import { MenuHomeComponent } from './menu-home/menu-home.component';
import { SituationComponent } from './situation/situation.component';
import { TemplateComponent } from './template/template.component';
import { FechaTimestampPipe } from './../../pipes/fecha-timestamp.pipe';
import { TablaDinamicaBuscadorComponent } from "./tabla-dinamica-buscador/tabla-dinamica-buscador.component";
import { TitleComponent } from "./title/title.component";
import { FilterComponent } from './filter/filter.component';
import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { LoginSdkComponent } from "./login-sdk/login-sdk.component";
import { SpinnerComponent } from "./spinner/spinner.component";
import { ModalTradeMonedaComponent } from "./modal-trade-moneda/modal-trade-moneda.component";
import { ModalTradeComponent } from "./modal-trade/modal-trade.component";
import { ModalDoublePreviewComponent } from "./modal-double-preview/modal-double-preview.component";
import { ModalHistoryModule } from "./modal-history/modal-history.module";
import { ModalSearchForMatchkeyComponent } from "./modal-search-for-matchkey/modal-search-for-matchkey.component";
import { ModalDominioSubdominioComponent } from "./modal-dominio-subdominio/modal-dominio-subdominio.component";
import { EmptyMessageComponent } from "./empty-message/empty-message.component";
import { NotificationsAlertComponent } from "./notifications-alert/notifications-alert.component";
import { NotificationsToggleComponent } from "./notifications-toggle/notifications-toggle.component";
import { NotificationsContainerComponent } from "./notifications-container/notifications-container.component";
import { ModalAbmBuscadorSettingsComponent } from "./modal-abm-buscador-settings/modal-abm-buscador-settings.component";
import { ModalConfigSelectionComponent } from "./modal-config-selection/modal-config-selection.component";

const DECLARATIONS = [
  ButtonFuentesMenuComponent,
  ConfirmationDialogComponent,
  DateInputDialogComponent,
  CountryListComponent,
  FloatButtonComponent,
  FooterComponent,
  FormularioDinamicoComponent,
  HistorialFuentesPanelComponent,
  HomeComponent,
  HomeSearcherComponent,
  MensajeComponent,
  MenuHomeComponent,
  ModalAbmBuscadorComponent,
  ModalComponent,
  ModalBcraComponent,
  ModalEliminacionMasivaComponent,
  ModalLateralComponent,
  NavbarComponent,
  NominativeComponent,
  NominativeRdsComponent,
  NotificationsComponent,
  OverlayLoadingComponent,
  PreviewDataTableFuenteComponent,
  PreviewDataTableTitleComponent,
  SidebarComponent,
  HealthComponent,
  SituationComponent,
  TitleComponent,
  BreadcrumbComponent,
  FilterComponent,
  SpinnerComponent,
  ModalTradeComponent,
  ModalDoublePreviewComponent,
  ModalTradeMonedaComponent,
  ModalDominioSubdominioComponent,
];

const STANDALONE_COMPONENTS = [
  EmptyMessageComponent,
  LoginSdkComponent,
  ModalSearchForMatchkeyComponent,
  NotificationsToggleComponent,
  NotificationsAlertComponent,
  NotificationsContainerComponent,
  TablaDinamicaBuscadorComponent,
  TabsSourcesComponent,
  TemplateComponent,
  ModalAbmBuscadorSettingsComponent,
  ModalConfigSelectionComponent,
];

@NgModule({
  declarations: [DECLARATIONS],
  imports: [
    CommonModule,
    FormsModule,
    NgxDatatableModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    HelpersModule,
    PipesModule,
    SignalDesignModule,
    ModalHistoryModule,
    STANDALONE_COMPONENTS,
  ],
  exports: [DECLARATIONS, HelpersModule, NgxDatatableModule, STANDALONE_COMPONENTS],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    FechaTimestampPipe,
  ],
})

export class SharedModule { }
